// XAxisProps.tsx
import React from 'react';
import AxisProps from './AxisOptions';
import {
  ChartConAxisOptions,
  ChartConXAxis,
} from '../../../../redux/ChartPoperties/ChartControlsInterface';

const axisOptionsForX = [
  { type: 'Bottom', value: 'bottom' },
  { type: 'Top', value: 'top' },
  { type: 'Hide', value: 'hide' },
];

const positions = [
  { name: 'Start', value: 'start' },
  { name: 'Middle', value: 'middle' },
  { name: 'End', value: 'end' },
];

interface XAxisPropsComponentProps {
  propKey: string;
  chartType: string;
  property: ChartConAxisOptions & {
    scatterChartMinMax: {
      x_enableMin: boolean;
      x_minValue: number;
      x_enableMax: boolean;
      x_maxValue: number;
    };
    xSplitLine: boolean;
  };
  xAxisProps: ChartConXAxis;
  updateAxisOptions: (axis: string, option: string, value: any) => void;
  updateAxisMinMaxforScatter: (axisKey: string, value: any) => void;
  enableGrids: (propKey: string, option: string, value: any) => void;
  iconColor?: string;
  backgroundColor?: string;
}

const XAxisProps: React.FC<XAxisPropsComponentProps> = ({
  propKey,
  chartType,
  property,
  xAxisProps,
  updateAxisOptions,
  updateAxisMinMaxforScatter,
  enableGrids,
  iconColor,
  backgroundColor,
}) => {
  return (
    //renders the component from AxisOptions.tsx, for change in component refer to AxisOptions.tsx
    <AxisProps
      propKey={propKey}
      chartType={chartType}
      axisType="x"
      property={property}
      axisProps={xAxisProps}
      updateAxisOptions={updateAxisOptions}
      updateAxisMinMaxforScatter={updateAxisMinMaxforScatter}
      enableGrids={enableGrids}
      positions={positions}
      axisOptions={axisOptionsForX}
      iconColor={iconColor}
      backgroundColor={backgroundColor}
    />
  );
};

export default XAxisProps;
